document.documentElement.classList.add("js");

// Hero recording clock ticks up like a live take.
(function () {
  const clock = document.getElementById("rec-clock");
  if (!clock) return;
  let s = 0;
  setInterval(() => {
    s += 1;
    clock.textContent = Math.floor(s / 60) + ":" + String(s % 60).padStart(2, "0");
  }, 1000);
})();

// Hero headline types itself like live transcription.
(function () {
  const h1 = document.getElementById("typed-h1");
  if (!h1) return;
  const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduced) return;
  const words = h1.textContent.trim().split(" ");
  h1.style.minHeight = h1.offsetHeight + "px"; // reserve space so typing doesn't shift the layout
  h1.textContent = "";
  const caret = document.createElement("span");
  caret.className = "caret";
  h1.appendChild(caret);
  let i = 0;
  (function next() {
    if (i >= words.length) { h1.style.minHeight = ""; return; }
    if (i) caret.before(" ");
    if (words[i] === "Cube") {
      const hl = document.createElement("span");
      hl.className = "hl";
      hl.textContent = words[i];
      caret.before(hl);
    } else {
      caret.before(words[i]);
    }
    i += 1;
    setTimeout(next, 260 + Math.random() * 240);
  })();
})();

// "In ⟨language⟩" scrollwheel under Record. Transcribe. Ask.
// All Scribe v2 languages (elevenlabs.io/docs), one per second.
(function () {
  const list = document.getElementById("lw-list");
  if (!list) return;
  const LANGS = [
    "English", "Estonian", "Filipino", "Finnish", "French", "Fulah",
    "Galician", "Ganda", "Georgian", "German", "Greek", "Gujarati",
    "Hausa", "Hebrew", "Hindi", "Hungarian", "Icelandic", "Igbo",
    "Indonesian", "Irish", "Italian", "Japanese", "Javanese",
    "Kabuverdianu", "Kannada", "Kazakh", "Khmer", "Korean", "Kurdish",
    "Kyrgyz", "Lao", "Latvian", "Lingala", "Lithuanian", "Luo",
    "Luxembourgish", "Macedonian", "Malay", "Malayalam", "Maltese",
    "Mandarin Chinese", "Māori", "Marathi", "Mongolian", "Nepali",
    "Northern Sotho", "Norwegian", "Occitan", "Odia", "Pashto",
    "Persian", "Polish", "Portuguese", "Punjabi", "Romanian", "Russian",
    "Serbian", "Shona", "Sindhi", "Sinhala", "Slovak", "Slovenian",
    "Somali", "Spanish", "Swahili", "Swedish", "Tamil", "Tajik",
    "Telugu", "Thai", "Turkish", "Ukrainian", "Umbundu", "Urdu",
    "Uzbek", "Vietnamese", "Welsh", "Wolof", "Xhosa", "Zulu",
    "Afrikaans", "Amharic", "Arabic", "Armenian", "Assamese",
    "Asturian", "Azerbaijani", "Belarusian", "Bengali", "Bosnian",
    "Bulgarian", "Burmese", "Cantonese", "Catalan", "Cebuano",
    "Chichewa", "Croatian", "Czech", "Danish", "Dutch",
  ];
  if (matchMedia("(prefers-reduced-motion: reduce)").matches) {
    document.getElementById("langwheel").innerHTML =
      '<span class="lw-in">In</span> <span class="lw-static">100 languages.</span>';
    return;
  }
  const items = LANGS.concat(LANGS.slice(0, 2)).map((name) => {
    const el = document.createElement("span");
    el.textContent = name;
    list.appendChild(el);
    return el;
  });
  let i = 0, timer;
  function set(idx, snap) {
    list.style.transition = snap ? "none" : "transform 0.35s ease";
    list.style.transform = "translateX(" + -items[idx].offsetLeft + "px)";
    items.forEach((el, j) => el.classList.toggle("on", j === idx));
  }
  function tick() {
    i += 1;
    set(i);
    if (i === LANGS.length) setTimeout(() => { i = 0; set(0, true); }, 400);
  }
  set(0, true);
  new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) { if (!timer) timer = setInterval(tick, 1000); }
    else { clearInterval(timer); timer = null; }
  }).observe(list);
})();

// Hero screen cycles through real captures: quiet day -> new recording
// appears -> transcribed and summarized.
(function () {
  const shots = [...document.querySelectorAll(".phone-real-shot")];
  if (shots.length < 2) return;
  const show = (i) => shots.forEach((s, j) => s.classList.toggle("on", i === j));
  if (matchMedia("(prefers-reduced-motion: reduce)").matches) {
    show(shots.length - 1);
    return;
  }
  const HOLD = [3600, 2600, 5200];
  let i = 0;
  (function next() {
    setTimeout(() => {
      i = (i + 1) % shots.length;
      show(i);
      next();
    }, HOLD[i]);
  })();
})();

// Scroll reveals.
(function () {
  const io = new IntersectionObserver(
    (entries) => entries.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
    }),
    { threshold: 0.15 }
  );
  document.querySelectorAll(".reveal, .reveal-x").forEach((el) => io.observe(el));
})();

// Step visuals autoplay independently: cube press/listen loop, then two
// typing loops. Nothing is tappable.
(function () {
  const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;

  const cube = document.getElementById("cube-demo");
  if (cube && !reduced) {
    (function loop() {
      cube.classList.remove("pressing");
      void cube.offsetWidth;
      cube.classList.add("pressing");
      setTimeout(() => cube.classList.add("listening"), 700);
      setTimeout(() => {
        cube.classList.remove("listening");
        cube.classList.remove("pressing");
      }, 4800);
      setTimeout(loop, 6200);
    })();
  }

  const tEl = document.getElementById("demo-transcript");
  const sEl = document.getElementById("demo-summary");
  const aEl = document.getElementById("demo-answer");
  const TRANSCRIPT =
    "…and if the tile runs late, we push a week. Either way you’re at " +
    "$18,500 all-in: cabinets, counters, and labor.";
  const SUMMARY =
    "Kitchen reno confirmed at $18,500 total. Work starts Tuesday; a late " +
    "tile delivery may add a week.";
  const ANSWER =
    "Yes. Work starts Tuesday, and a late tile delivery could add a week.";

  function typeText(el, text, done) {
    let k = 0;
    (function tick() {
      k += 1;
      el.textContent = text.slice(0, k);
      if (k >= text.length) { if (done) done(); }
      else setTimeout(tick, 32);
    })();
  }

  if (reduced) {
    if (tEl) tEl.textContent = TRANSCRIPT;
    if (sEl) sEl.textContent = SUMMARY;
    if (aEl) aEl.textContent = ANSWER;
    return;
  }
  // Transcribe canvas: transcript types first, then the summary.
  if (tEl && sEl) {
    (function loopTS() {
      tEl.textContent = "";
      sEl.textContent = "";
      typeText(tEl, TRANSCRIPT, () =>
        setTimeout(() =>
          typeText(sEl, SUMMARY, () => setTimeout(loopTS, 4600)), 600));
    })();
  }
  if (aEl) {
    (function loopA() {
      aEl.textContent = "";
      typeText(aEl, ANSWER, () => setTimeout(loopA, 5200));
    })();
  }
})();


// Buy-box photo carousel: arrows + thumbnails, native scroll-snap.
(function () {
  const track = document.getElementById("carousel-track");
  const thumbs = document.getElementById("thumbs");
  if (!track || !thumbs) return;
  const slides = [...track.children];
  const btns = [...thumbs.children];
  const index = () => Math.round(track.scrollLeft / track.clientWidth);
  const go = (i) => {
    i = (i + slides.length) % slides.length;
    track.scrollTo({ left: i * track.clientWidth, behavior: "smooth" });
  };
  document.querySelectorAll(".carousel-arrow").forEach((b) =>
    b.addEventListener("click", () => go(index() + Number(b.dataset.dir)))
  );
  btns.forEach((b, i) => b.addEventListener("click", () => {
    go(i);
    if (matchMedia("(max-width: 767px)").matches) document.getElementById("carousel").scrollIntoView({ behavior: "smooth", block: "start" });
  }));
  window.bloccGo = go;
  let raf;
  track.addEventListener("scroll", () => {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      const i = index();
      btns.forEach((b, k) => b.classList.toggle("is-active", k === i));
      if (btns[i]) { const b = btns[i]; if (b.offsetLeft < thumbs.scrollLeft) thumbs.scrollLeft = b.offsetLeft; else if (b.offsetLeft + b.offsetWidth > thumbs.scrollLeft + thumbs.clientWidth) thumbs.scrollLeft = b.offsetLeft + b.offsetWidth - thumbs.clientWidth; }
    });
  }, { passive: true });
})();

// "Get it by" date from the shipping policy (late end of 1-2 business days processing + 3-8 in transit), with a live
// "Order in Xh Ym" countdown to the same-day cutoff (settings.ship_cutoff_hour, US Eastern). After the cutoff the date rolls a day.
(function () {
  const els = document.querySelectorAll("[data-eta]");
  if (!els.length) return;
  const cutoff = Number(document.querySelector("[data-cutoff-hour]")?.dataset.cutoffHour ?? 14);
  const tz = "America/New_York";
  const partsNow = () => {
    const p = Object.fromEntries(new Intl.DateTimeFormat("en-US", { timeZone: tz, hour12: false, year: "numeric", month: "numeric", day: "numeric", hour: "numeric", minute: "numeric", weekday: "short" }).formatToParts(new Date()).map((x) => [x.type, x.value]));
    return { y: +p.year, m: +p.month, d: +p.day, h: +p.hour % 24, min: +p.minute, wd: p.weekday };
  };
  const addBiz = (start, n) => {
    const d = new Date(start);
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n -= 1; }
    return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
  };
  const tick = () => {
    const n = partsNow();
    const start = new Date(n.y, n.m - 1, n.d);
    const minsLeft = (cutoff * 60) - (n.h * 60 + n.min);
    const weekday = n.wd !== "Sat" && n.wd !== "Sun";
    const live = weekday && minsLeft > 0;
    if (!live) start.setDate(start.getDate() + 1);
    const by = addBiz(start, 10);
    els.forEach((el) => {
      el.querySelector("b").textContent = by;
      const lead = el.querySelector("[data-eta-lead]");
      if (lead) lead.textContent = live ? "Order in " + Math.floor(minsLeft / 60) + "h " + (minsLeft % 60) + "m to get it by" : "Get it by";
      el.hidden = false;
    });
  };
  tick();
  setInterval(tick, 30000);
})();

// Plan picker (snippets/offer.liquid): the chosen plan drives every price, the buy links and the product form's variant (so Shop Pay follows). A welcome discount already in the browser (Shopify's discount_code cookie) switches the
// prices to the discounted ones; checkout applies the same code.
(function () {
  const plans = document.querySelectorAll("[data-plan]");
  if (!plans.length) return;
  const offer = document.querySelector("[data-offer]");
  const code = (offer.dataset.welcomeCode || "").toLowerCase();
  const cookie = document.cookie.match(/(?:^|; )discount_code=([^;]*)/);
  const welcome = !!(code && cookie && decodeURIComponent(cookie[1]).toLowerCase() === code);
  const ph = (e, p) => { if (window.posthog && posthog.capture) posthog.capture(e, p); };
  const cents = (t) => Math.round(parseFloat(t.replace(/[^0-9.]/g, "")) * 100);
  const fmt = (c) => "$" + (c / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const countTo = (el, text) => {
    const from = cents(el.textContent || "0"), to = cents(text);
    if (!isFinite(from) || from === to) { el.textContent = text; return; }
    const t0 = performance.now();
    const step = (t) => {
      const k = Math.min(1, (t - t0) / 450), e = 1 - Math.pow(1 - k, 3);
      el.textContent = fmt(Math.round(from + (to - from) * e));
      if (k < 1) requestAnimationFrame(step); else el.textContent = text;
    };
    requestAnimationFrame(step);
  };
  // Meter caption: one unit at a time (meetings, calls, lectures), rotating every 4s, paused while hovered.
  const cap = {
    units: ["meetings", "calls", "lectures"], i: 0, current: null, paused: false,
    show(animate) {
      const d = this.current; if (!d) return;
      const txt = "about " + d[this.units[this.i]] + " " + this.units[this.i];
      document.querySelectorAll("[data-meter-cap]").forEach((el) => {
        if (!animate || el.textContent === txt) { el.textContent = txt; return; }
        el.classList.add("out"); setTimeout(() => { el.textContent = txt; el.classList.remove("out"); }, 220);
      });
    },
  };
  document.querySelectorAll("[data-meter]").forEach((m) => { m.addEventListener("mouseenter", () => { cap.paused = true; }); m.addEventListener("mouseleave", () => { cap.paused = false; }); });
  if (matchMedia("(prefers-reduced-motion: no-preference)").matches) setInterval(() => { if (cap.paused || document.hidden) return; cap.i = (cap.i + 1) % cap.units.length; cap.show(true); }, 4000);
  const apply = (inp, animate) => {
    const d = inp.dataset, bundle = inp.value === "bundle";
    const price = welcome ? d.wprice : d.price, list = welcome ? d.wlist : d.list, href = welcome ? d.whref : d.href;
    document.querySelectorAll(".plan").forEach((l) => l.classList.toggle("is-on", l.contains(inp)));
    plans.forEach((p) => {
      const card = p.closest(".plan"), pl = card.querySelector("[data-plan-list]"), pp = card.querySelector("[data-plan-price]");
      const cl = welcome ? p.dataset.wlist : p.dataset.list;
      if (pl) { pl.textContent = cl; pl.hidden = !cl; }
      if (pp) pp.textContent = welcome ? p.dataset.wprice : p.dataset.price;
    });
    document.querySelectorAll("[data-price-out]").forEach((el) => (animate ? countTo(el, price) : (el.textContent = price)));
    document.querySelectorAll("[data-list-out]").forEach((el) => { el.textContent = list; el.hidden = !list; });
    document.querySelectorAll("[data-buy]").forEach((a) => { a.href = a.closest("#buybar") ? "#what-you-get" : href; a.textContent = d.label; a.dataset.plan = inp.value; });
    document.querySelectorAll("[data-variant-input]").forEach((i) => { i.value = d.variant; });
    const mins = Number(d.minutes) || 0, max = Math.max(...[...plans].map((p) => Number(p.dataset.minutes) || 0));
    const num = (n) => n.toLocaleString("en-US");
    document.querySelectorAll("[data-meter-fill]").forEach((el) => { el.style.width = (100 * mins / max) + "%"; el.classList.remove("sweep"); void el.offsetWidth; if (animate) el.classList.add("sweep"); });
    document.querySelectorAll("[data-meter-num]").forEach((el) => {
      const from = Number(el.textContent.replace(/,/g, "")) || mins;
      if (!animate || from === mins) { el.textContent = num(mins); return; }
      const t0 = performance.now();
      const step = (t) => { const k = Math.min(1, (t - t0) / 650), e = 1 - Math.pow(1 - k, 3); el.textContent = num(Math.round(from + (mins - from) * e)); if (k < 1) requestAnimationFrame(step); };
      requestAnimationFrame(step);
    });
    document.querySelectorAll("[data-meter]").forEach((el) => el.classList.toggle("is-max", mins === max));
    cap.current = d; cap.show(animate);
    if (animate && bundle) document.querySelectorAll(".plan-tag").forEach((el) => { el.classList.remove("pop"); void el.offsetWidth; el.classList.add("pop"); });
    if (animate && window.bloccGo) window.bloccGo(bundle ? (Number(offer.dataset.bundleSlide) || 3) - 1 : 0);
    document.querySelectorAll("[data-welcome-note]").forEach((el) => { el.hidden = !welcome; });
  };
  plans.forEach((inp) => inp.addEventListener("click", () => document.getElementById("buybar")?.classList.add("plan-chosen")));
  plans.forEach((inp) => inp.addEventListener("change", () => {
    apply(inp, true);
    ph("plan_select", { plan: inp.value, welcome });
  }));
  apply(document.querySelector("[data-plan]:checked") || plans[0], false);
  if (matchMedia("(hover: hover) and (prefers-reduced-motion: no-preference)").matches) {
    document.querySelectorAll(".plan").forEach((card) => {
      card.addEventListener("mousemove", (e) => {
        const r = card.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        card.style.setProperty("--rx", (-y * 5).toFixed(2) + "deg"); card.style.setProperty("--ry", (x * 6).toFixed(2) + "deg");
      });
      card.addEventListener("mouseleave", () => { card.style.setProperty("--rx", "0deg"); card.style.setProperty("--ry", "0deg"); });
    });
  }
  if (welcome) ph("welcome_code_seen", { code });
})();

// Live member count from loopsh.com/stats.json (CORS open, cached 15 min). The number rolls up from 0 once the line is on
// screen and the tab is active, never in a background tab. If the fetch fails it rolls to the Liquid fallback and keeps the "+".
(function () {
  const els = document.querySelectorAll("[data-members]");
  if (!els.length) return;
  const roll = (el, to, suffix) => {
    const t0 = performance.now();
    const step = (t) => { const k = Math.min(1, (t - t0) / 1400), e = 1 - Math.pow(1 - k, 3); el.textContent = Math.round(to * e).toLocaleString("en-US") + (k < 1 ? "" : suffix); if (k < 1) requestAnimationFrame(step); };
    requestAnimationFrame(step);
  };
  let target = null, suffix = "";
  const done = new Set(), inView = new Set();
  const maybe = () => {
    if (target === null || document.visibilityState !== "visible") return;
    inView.forEach((el) => { if (!done.has(el)) { done.add(el); roll(el, target, suffix); } });
  };
  const io = new IntersectionObserver((en) => { en.forEach((x) => { if (x.isIntersecting) inView.add(x.target); else inView.delete(x.target); }); maybe(); }, { threshold: 0.6 });
  els.forEach((el) => { el.textContent = "0"; io.observe(el); });
  document.addEventListener("visibilitychange", maybe);
  const fallback = () => { const raw = els[0].dataset.fallback || "2,300+"; target = Number(raw.replace(/[^0-9]/g, "")) || 0; suffix = /\+$/.test(raw) ? "+" : ""; maybe(); };
  fetch("https://loopsh.com/stats.json").then((r) => r.json()).then((d) => {
    const n = d && d.apps && d.apps.members;
    if (n > 0) { target = n; suffix = ""; maybe(); } else fallback();
  }).catch(fallback);
})();

// Mobile sticky buy bar: the one buy path on small screens; steps aside while the buy box is on screen.
(function () {
  const bar = document.getElementById("buybar");
  const buy = document.getElementById("buy");
  if (!bar || !buy) return;
  new IntersectionObserver((entries) => bar.classList.toggle("off", entries[0].isIntersecting)).observe(buy);
})();

// PostHog: named funnel events on top of autocapture. No-ops if PostHog is blocked.
(function () {
  const ph = (e, p) => { if (window.posthog && posthog.capture) posthog.capture(e, p); };
  const q = (s) => document.querySelector(s);
  q(".topbar .btn-small")?.addEventListener("click", () => ph("cta_click", { label: "header_buy" }));
  q(".hero .btn-ghost")?.addEventListener("click", () => ph("cta_click", { label: "hero_how" }));
  q("[data-amazon]")?.addEventListener("click", () => ph("cta_click", { label: "amazon_buy" }));
  document.querySelectorAll("[data-buy]").forEach((b) => b.addEventListener("click", () =>
    ph("begin_checkout", { method: b.closest("#buybar") ? "sticky_bar" : "buy_now", plan: b.dataset.plan || "cube", welcome: /\/discount\//.test(b.href) })));
  q(".buy-form")?.addEventListener("click", (e) => {
    const more = e.target.closest("more-payment-options-link, .shopify-payment-button__more-options");
    ph("begin_checkout", { method: more ? "more_options" : "express_wallet" });
  });
  document.querySelectorAll(".carousel-arrow").forEach((b) => b.addEventListener("click", () => ph("carousel_arrow", { dir: Number(b.dataset.dir) })));
  document.querySelectorAll(".thumb").forEach((b, i) => b.addEventListener("click", () => ph("carousel_thumb", { index: i })));
  document.querySelectorAll(".faq details").forEach((d) => d.addEventListener("toggle", () => {
    if (d.open) ph("faq_open", { question: d.querySelector("summary")?.textContent.trim() });
  }));
  q(".contact-form")?.addEventListener("submit", () => ph("contact_submit"));
  const seen = new Set();
  const io = new IntersectionObserver((entries) => entries.forEach((en) => {
    if (!en.isIntersecting || seen.has(en.target)) return;
    seen.add(en.target); io.unobserve(en.target);
    ph("section_viewed", { section: en.target.id || en.target.className.split(" ")[0] });
  }), { threshold: 0.3 });
  document.querySelectorAll("main section").forEach((s) => io.observe(s));
})();

// Welcome-form redirect: Shopify treats encoded fragments as paths, so scroll after returning to the homepage.
if (new URLSearchParams(location.search).get("welcome") === "1") {
  const target = document.getElementById("what-you-get");
  if (target) window.addEventListener("load", () => target.scrollIntoView({ block: "start" }), { once: true });
}
